const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');

for (let i = 0; i < smoothScrollTrigger.length; i++) {
    smoothScrollTrigger[i].addEventListener('click', (e) => {

        e.preventDefault();
        let href = smoothScrollTrigger[i].getAttribute('href');
        let targetElement = document.getElementById(href.replace('#', ''));

        const rect = targetElement.getBoundingClientRect().top;
        const offset = window.pageYOffset;
        const gap = 60;
        const target = rect + offset - gap;

        window.scrollTo({
            top: target,
            behavior: 'smooth',
        });

    });

}

$(function () {

    function fadeUp() {
        $('.fade-up').not('.show').each(function () {
            const elemPos = $(this).offset().top;
            const scroll = $(window).scrollTop();
            const windowHeight = $(window).height();
            if (scroll + windowHeight > elemPos + 150) {
                $(this).addClass('show');
            }
        });
    }

    $(window).on('scroll', fadeUp);
    $(window).on('load', function () {
        setTimeout(fadeUp, 300);
    });


    const swiper = new Swiper('.vertical-swiper', {
        speed: 1000,
        mousewheel: true,
        slidesPerView: 1.5,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1.15,
                spaceBetween: 25,
            },
            835: {
                slidesPerView: 1.5,
                spaceBetween: 100,
            }
        }
    });

    $('.faq-question').on('click', function () {
        const $faqItem = $(this).closest('.faq-item');
        const $answer = $faqItem.find('.faq-answer');

        // 自分以外は閉じる（必要なら）
        $('.faq-item').not($faqItem).removeClass('open').find('.faq-answer').slideUp(300);

        // 自分をトグル
        $faqItem.toggleClass('open');
        $answer.stop(true, true).slideToggle(300);
    });

});


$(window).on('load', function () {
    setTimeout(function () {
        $('.fv-txt').addClass('active');
    }, 700); // 1000ミリ秒 = 1秒
});
